import publicIp from 'public-ip';
import { IncomingMessage } from 'http';
import config from './config';

export default async function getIpAddress(req: IncomingMessage): Promise<string | undefined> {
  if (config.nodeEnv === 'development') {
    return publicIp.v4();
  }

  // attempt to extract client ip from x-forwarded-for
  // see https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Forwarded-For
  const forwardedFor = req.headers['x-forwarded-for'];
  if (typeof forwardedFor === 'string' && forwardedFor) {
    const clientIP = forwardedFor.split(/\s*,\s*/)[0];
    if (clientIP) {
      return clientIP;
    }
  }

  // otherwise detect the ip from the socket
  return req.socket.remoteAddress;
}
